import React, { useEffect, useState } from "react";
import { FaUser, FaFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import taskAPI from "../api/taskAPI";
import UserDashboard from "./UserDashboard";

const CompanyWorkersReports = () => {

  const [workers, setWorkers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchWorkers();
  }, []);

  const fetchWorkers = async () => {
    try {
      const res = await taskAPI.get("/developer-members");
      setWorkers(res.data.members);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-6">
      <UserDashboard />

      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 flex items-center gap-2">
          <FaUser className="text-green-600" />
          Company Workers
        </h1>
        <p className="text-gray-600 mt-2">
          View reports submitted by your workers
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                Worker Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                View Reports
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {workers.map(worker => (
              <tr key={worker._id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm text-gray-900">
                  {worker.username}
                </td>

                <td className="px-6 py-4">
                  <button
                    onClick={() =>navigate(`/worker-reports/${worker.username}`)}
                    className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                  >
                    <FaFileAlt />
                    View Reports
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {workers.length === 0 && (
          <div className="p-6 text-center text-gray-500">
            No workers found
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyWorkersReports;